export default __webpack_public_path__ + "static/media/farming.5f21885a.svg";